import React, { Component } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

// This is a class-based component because the current 
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class CaseFormWrapper extends Component {
  constructor(props) {
    super(props);
    this.onhashchange = this.onhashchange.bind(this);
    this.expanderClicked = this.expanderClicked.bind(this);
    this.titleChildren = this.titleChildren.bind(this);
    this.state = {
      cardFocused: this.props.formId == "Header" ? true : false,
      justPrompted: false,
      reloadForm: false
    };
  }

  componentDidMount() {
    window.addEventListener("hashchange", this.onhashchange);
    if (this.props.expandOnLoad) this.expanderClicked(true);
  }

  componentDidUpdate() {
    if (this.state.reloadForm) {
      this.props.formStatusChange(this.props.formTitle, "clean", this.props.formId);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.onhashchange);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.allCardsExpanded != null && !this.state.justPrompted) {
      this.setState({ justPrompted: true });
      if (this.props.formId != "Header") {
        if (nextProps.allCardsExpanded) {
          this.expanderClicked(true);
        } else {
          this.expanderClicked(false);
        }
      }
    } else if (nextProps.allCardsExpanded === null && this.state.justPrompted) {
      this.setState({ justPrompted: false });
    }
    // Trigger a reload of the form when required
    if (this.state.reloadForm) {
      this.setState({ reloadForm: false });
      this.props.formStatusChange(this.props.formTitle, "clean", this.props.formId);
    }
    if (this.props.formStatus === "needsRefresh" && !this.state.reloadForm) {
      this.setState({ reloadForm: true });
    }
    if (window.location.hash.length > 0) {
      this.onhashchange();
    }
  }

  onhashchange() {
    if (window.location.hash == `#${this.props.formId}`) {
      if (!this.state.cardFocused) {
        this.expanderClicked(true);
      }
    }
  }

  expanderClicked(val) {
    const { onClick, formId } = this.props;

    let resp = true;
    if (
      !val &&
      this.props.formStatus != "clean" &&
      this.props.formStatus != "saveSuccess"
    ) {
      resp = confirm(
        `${
        this.props.formTitle
        } has unsaved changes, are you sure you want to close this form?`
      );
    }
    if (resp) {
      this.setState({ cardFocused: val });
      if (!val) {
        this.props.formStatusChange(this.props.formTitle, "clean", this.props.formId);
        history.replaceState("", document.title, window.location.pathname + window.location.search);
      }
    }
    if (this.props.formId === "home-header") {
      this.props.toggleHeaderClassName();
    }
    if (onClick) {
      onClick(val, formId);
    }
  }

  titleChildren() {
    let buttons = [];
    return (<div className="md-full-width">
      {this.props.toolbar}
      {this.props.summaryInfo &&
        <span style={{ color: "#c8102e", fontSize: "1.25rem", padding: 5 }}>
          {this.props.summaryInfo()}
        </span>
      }
      {buttons}
    </div>);
  }

  render() {
    
    let formTitle = this.props.formTitle;
    let formLockedDivStyle = {
      display: "none", // hidden unless formLocked is true
      position: "absolute",
      top: "0",
      left: "0",
      height: "100%",
      width: "100%",
      backgroundColor: "#cccccc55" // 55 is transparency level
    };
    if (this.props.formLocked) {
      formTitle = formTitle + " (READ ONLY: SHARED DATA)";
      formLockedDivStyle.display = "inherit"; // make the form locking overlay div visible
    }
    return (
      <div className="case-form-wrapper" id={this.props.formId}>
        <Card>
          <CardContent
            style={{ cursor: "pointer" }}
            onClick={() => this.expanderClicked(!this.state.cardFocused)}
          >
            <Typography variant="h6" style={{ whiteSpace: "nowrap" }}>{formTitle}</Typography>
            {this.titleChildren()}
          </CardContent>
          {!this.state.reloadForm && this.state.cardFocused && (
            <CardContent className="expandable-area">
              <div style={{ position: "relative" }}>
                {this.props.comp}
                <div style={formLockedDivStyle}>&nbsp;</div>
              </div>
            </CardContent>
          )}
        </Card>
      </div>
    );
  }
}

CaseFormWrapper.propTypes = {
  toolbar: PropTypes.object,
  comp: PropTypes.object,
  formId: PropTypes.string.isRequired,
  formTitle: PropTypes.string.isRequired,
  formStatusChange: PropTypes.func.isRequired,
  formStatus: PropTypes.string,
  allCardsExpanded: PropTypes.bool,
  //expandOnLoad works just like the allCardsExpanded but the allCardsExpanded functionality does not work on load.
  //i was going to make it work on load but didnt know if it would break functionality of other pages so i made another prop
  expandOnLoad: PropTypes.bool,
  formLocked: PropTypes.bool,
  toggleHeaderClassName: PropTypes.func,
  summaryInfo: PropTypes.func,
  onClick: PropTypes.func,
};

export default CaseFormWrapper;
